var e={short:{value:"100ms"},medium:{value:"250ms"},long:{value:"500ms"}};export{e as time};
//# sourceMappingURL=time.js.map
